import { useTranslation } from 'react-i18next'

import { combinedFields } from '@ana/shared'
import { FieldSettings, Optins } from '@ana/shared'
import { Grid } from '@mui/material'

import Group from '../Group'
import PreviewField from '../PreviewField'
import { PreviewFieldProps } from '../PreviewField/PreviewField'
import Title from '../Title'

type Props = {
  optins?: Optins
  getEditableFieldProps: (settings: Omit<FieldSettings, '__type'>) => Omit<PreviewFieldProps, 'transform'>
  shouldShowCancellationNotice?: boolean
}

export const SummaryOptins = ({ optins, getEditableFieldProps, shouldShowCancellationNotice = true }: Props) => {
  const { t } = useTranslation()

  return (
    <>
      <Title>{t('category.optins')}</Title>

      <Group>
        {optins && (
          <>
            <Grid size={{ xs: 12 }}>
              <PreviewField
                {...getEditableFieldProps(combinedFields.confidentialityAgreementAccepted)}
                value={optins.confidentialityAgreementAccepted}
              />
            </Grid>
            <Grid size={{ xs: 12 }}>
              <PreviewField
                {...getEditableFieldProps(combinedFields.marketingCommunicationConsentAccepted)}
                value={optins.marketingCommunicationConsentAccepted}
              />
            </Grid>
          </>
        )}
        {shouldShowCancellationNotice && (
          <Grid size={{ xs: 12 }}>
            <PreviewField label={'summary.cancellation_notice'} value={true} />
          </Grid>
        )}
      </Group>
    </>
  )
}
